var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"header-box"},[_c('mars-view',{staticClass:"bg",style:('background-image: url(' + _vm.info.header_link + ')')}),_c('mars-view',{staticClass:"radius-box"}),_c('mars-view',{staticClass:"h-swiper-box"},[(_vm.swiperList.length)?_c('ui-swiper',{attrs:{"swiper-list":_vm.swiperList}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }